import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import { Carousel, Navbar, Nav, Container, Row, Col, Card, ListGroup, Modal } from 'react-bootstrap';
import { Clock, MapPin, Instagram, MessageCircle, Mail } from 'lucide-react'; // Ícones modernos
import AOS from 'aos';
import 'aos/dist/aos.css';

// ============================================================================
// IMAGENS ESTÁTICAS DO SITE
// Para trocar uma foto: substitua o arquivo dentro da pasta "public/images"
// do projeto mantendo o mesmo nome, OU troque o caminho abaixo pelo nome do
// novo arquivo que você colocar lá. Não precisa mexer em mais nada no código.
// ============================================================================
const HERO_IMAGENS_ESTATICAS = [
  '../ativa-img/1000160099.jpg',
  '../ativa-img/1000160102.jpg',
];

const SOBRE_IMAGEM_ESTATICA = '../ativa-img/1000160108.png';

const INSTALACOES_IMAGENS_ESTATICAS = [
  '../ativa-img/1000160099.jpg',
  '../ativa-img/1000160102.jpg',
  '../ativa-img/1000160105.jpg',
  '../ativa-img/1000160108.png',
  '../ativa-img/1000160111.jpg',
  '../ativa-img/1000160114.jpg',
  '../ativa-img/1000160117.jpg',
  '../ativa-img/1000160123.jpg',
  '../ativa-img/1000160129.jpg',
  
];

const Home = () => {
  const [info, setInfo] = useState({ 
    nome: "Carregando...", 
    sobre: "", 
    endereco: "", 
    horariosEstruturados: {}, 
    planos: [],
    carouselImages: [],
    sobreImage: "",
    instalacoesImages: []
  });

  // Lightbox das fotos das instalações
  const [lightboxImg, setLightboxImg] = useState(null);
  const [showLightbox, setShowLightbox] = useState(false);

  useEffect(() => {
    document.title = "Academia Ativa";
    AOS.init({ duration: 1200, once: true });
    
    // Escuta em tempo real as mudanças feitas no Admin
    const unsub = onSnapshot(doc(db, "configuracoes", "geral"), (doc) => {
      if (doc.exists()) setInfo(doc.data());
    });
    return () => unsub();
  }, []);

  const ordemDosDias = [
    "segunda-feira", "terça-feira", "quarta-feira", 
    "quinta-feira", "sexta-feira", "sábado", "domingo"
  ];

  return (
    <div style={{ backgroundColor: '#121212', color: 'white', overflowX: 'hidden' }}>
      
      {/* Navbar */}
      <Navbar variant="dark" expand="lg" fixed="top" style={{ backgroundColor: 'rgba(0,0,0,0.9)', borderBottom: '1px solid #FF8C00' }}>
        <Container>
          <Navbar.Brand href="#" style={{ color: '#FF8C00', fontWeight: 'bold', fontSize: '1.5rem' }}>
            {/*{info.nome.toUpperCase()} */}
            <img src='logo1.png' width={130} height={80} alt="Logo da Empresa" className="nav-logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto text-uppercase fw-bold">
              <Nav.Link href="#sobre" className="mx-2">Sobre</Nav.Link>
              <Nav.Link href="#instalacoes" className="mx-2">Instalações</Nav.Link>
              <Nav.Link href="#horarios" className="mx-2">Horários</Nav.Link>
              <Nav.Link href="#planos" className="mx-2">Planos</Nav.Link>
              <Nav.Link href="#contato" className="mx-2">Contato</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* ============================================================
          CÓDIGO DINÂMICO (requer backend de upload) - mantido como referência
          ============================================================
      {(() => {
        const images = info.carouselImages && info.carouselImages.length > 0
          ? info.carouselImages
          : ['https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=2070'];
        const isSlider = images.length >= 2;
        return (
          <Carousel
            fade={!isSlider}
            controls={isSlider}
            indicators={isSlider}
            interval={isSlider ? 4000 : null}
          >
            {images.map((img, idx) => (
              <Carousel.Item key={idx} className="vh-100">
                <div className="d-flex align-items-center h-100 w-100" style={{
                  backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url("${img}")`,
                  backgroundSize: 'cover', backgroundPosition: 'center'
                }}>
                  <Container className="text-center" data-aos="zoom-in">
                    <h1 style={{ fontSize: '4.5rem', fontWeight: '900', letterSpacing: '-2px' }}>
                      <span style={{ color: '#FF8C00' }}>{info.nome.toUpperCase()}</span>
                    </h1>
                    <p className="lead fs-3 mt-3">Transforme seu corpo, domine sua mente.</p>
                    <a href="#planos" className="btn btn-warning btn-lg mt-4 fw-bold px-5 py-3" style={{ backgroundColor: '#FF8C00', border: 'none' }}>VER HORÁRIOS</a>
                  </Container>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        );
      })()}
      ============================================================ FIM CÓDIGO DINÂMICO ============================================================ */}

      {/* ============================ VERSÃO ESTÁTICA (ativa) - Hero Carousel ============================ */}
      {(() => {
        const images = HERO_IMAGENS_ESTATICAS;
        const isSlider = images.length >= 2;
        return (
          <Carousel
            fade={!isSlider}
            controls={isSlider}
            indicators={isSlider}
            interval={isSlider ? 4000 : null}
          >
            {images.map((img, idx) => (
              <Carousel.Item key={idx} className="vh-100">
                <div className="d-flex align-items-center h-100 w-100" style={{
                  backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url("${img}")`,
                  backgroundSize: 'cover', backgroundPosition: 'center'
                }}>
                  <Container className="text-center" data-aos="zoom-in">
                    <h1 style={{ fontSize: '4.5rem', fontWeight: '900', letterSpacing: '-2px' }}>
                      <span style={{ color: '#FF8C00' }}>{info.nome.toUpperCase()}</span>
                    </h1>
                    <p className="lead fs-3 mt-3">Transforme seu corpo, domine sua mente.</p>
                    <a href="#planos" className="btn btn-warning btn-lg mt-4 fw-bold px-5 py-3" style={{ backgroundColor: '#FF8C00', border: 'none' }}>VER HORÁRIOS</a>
                  </Container>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        );
      })()}

      {/* Seção Sobre (Dinâmica) */}
      <section id="sobre" className="py-5 mt-5">
        <Container>
          <Row className="align-items-center">
            <Col md={6} data-aos="fade-right">
              <h2 className="display-5 fw-bold mb-4" style={{ color: '#FF8C00' }}>SOBRE NÓS</h2>
              <p className="fs-5 text-secondary" style={{ lineHeight: '1.8' }}>
                {info.sobre || "Informações sobre a academia em breve..."}
              </p>
            </Col>
            <Col md={6} data-aos="fade-left" className="text-center">
              {/* ===== CÓDIGO DINÂMICO (requer backend de upload) - mantido como referência
              <img 
                src={info.sobreImage || "academia2.jpg"} 
                alt="Treino" 
                className="img-fluid rounded shadow-lg border-start border-warning" 
                style={{ borderWidth: '8px !important' }}
              />
              ===== FIM CÓDIGO DINÂMICO ===== */}

              {/* ===== VERSÃO ESTÁTICA (ativa) ===== */}
              <img
                src={SOBRE_IMAGEM_ESTATICA}
                alt="Treino"
                className="img-fluid rounded shadow-lg border-start border-warning"
                style={{ borderWidth: '8px !important' }}
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Seção Instalações (Dinâmica) */}
      <section id="instalacoes" className="py-5">
        <Container>
          <h2 className="text-center display-5 fw-bold mb-5" data-aos="fade-down">
            NOSSAS <span style={{ color: '#FF8C00' }}>INSTALAÇÕES</span>
          </h2>

          {/* ===== CÓDIGO DINÂMICO (requer backend de upload) - mantido como referência
          {info.instalacoesImages && info.instalacoesImages.length > 0 ? (
            <Row className="g-3">
              {info.instalacoesImages.map((url, idx) => (
                <Col xs={6} md={4} key={idx} data-aos="zoom-in" data-aos-delay={idx * 100}>
                  <div
                    className="instalacao-thumb rounded shadow-lg"
                    onClick={() => {
                      setLightboxImg(url);
                      setShowLightbox(true);
                    }}
                  >
                    <img
                      src={url}
                      alt={`Instalação ${idx + 1}`}
                      className="img-fluid"
                    />
                  </div>
                </Col>
              ))}
            </Row>
          ) : (
            <p className="text-center text-muted">Fotos das instalações em breve...</p>
          )}
          ===== FIM CÓDIGO DINÂMICO ===== */}

          {/* ===== VERSÃO ESTÁTICA (ativa) ===== */}
          {INSTALACOES_IMAGENS_ESTATICAS.length > 0 ? (
            <Row className="g-3">
              {INSTALACOES_IMAGENS_ESTATICAS.map((url, idx) => (
                <Col xs={6} md={4} key={idx} data-aos="zoom-in" data-aos-delay={idx * 100}>
                  <div
                    className="instalacao-thumb rounded shadow-lg"
                    onClick={() => {
                      setLightboxImg(url);
                      setShowLightbox(true);
                    }}
                  >
                    <img
                      src={url}
                      alt={`Instalação ${idx + 1}`}
                      className="img-fluid"
                    />
                  </div>
                </Col>
              ))}
            </Row>
          ) : (
            <p className="text-center text-muted">Fotos das instalações em breve...</p>
          )}
        </Container>

        {/* Lightbox: abre a foto ampliada ao clicar */}
        <Modal
          show={showLightbox}
          onHide={() => setShowLightbox(false)}
          centered
          size="lg"
        >
          <Modal.Body className="p-0 bg-black">
            {lightboxImg && (
              <img src={lightboxImg} alt="Instalação ampliada" className="img-fluid w-100" />
            )}
          </Modal.Body>
        </Modal>
      </section>

      {/* Seção Horários (Dinâmica) */}
      <section id="horarios" className="py-5 bg-dark">
        <Container>
          <Row className="justify-content-center text-center" data-aos="fade-up">
            <Col md={8}>
              <div className="mb-4">
                <Clock color="#FF8C00" size={48} />
              </div>
              <h2 style={{ color: '#FF8C00', fontWeight: 'bold' }} className="mb-4 text-uppercase">
                Horários de Funcionamento
              </h2>
              <div 
                className="p-4 rounded shadow-lg bg-black" 
                style={{ borderLeft: '5px solid #FF8C00' }}
              >
                {info.horariosEstruturados ? (
                  ordemDosDias.map((dia) => {
                    const tempo = info.horariosEstruturados[dia];
                    const isFechado = !tempo || (!tempo.abertura && !tempo.fechamento);

                    return (
                      <div key={dia} className="d-flex justify-content-between fs-5 mb-2 border-bottom border-secondary pb-2">
                        <span className="text-capitalize" style={{ color: '#FF8C00' }}>{dia}</span>
                        <span>{isFechado ? <span className="text-muted">Fechado</span> : `${tempo.abertura} às ${tempo.fechamento}`}</span>
                      </div>
                    );
                  })
                ) : (
                  <p>Carregando horários...</p>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Seção Planos (Dinâmica) */}
      <section id="planos" className="py-5">
        <Container>
          <h2 className="text-center display-5 fw-bold mb-5" data-aos="fade-down">
            NOSSOS <span style={{ color: '#FF8C00' }}>PLANOS</span>
          </h2>
          <Row className="g-4">
            {info.planos && info.planos.length > 0 ? (
              info.planos.map((plano, idx) => (
                <Col md={4} key={idx} data-aos="flip-left" data-aos-delay={idx * 150}>
                  <Card className="bg-dark text-white border-warning h-100 shadow-lg hover-zoom">
                    <Card.Body className="p-4 d-flex flex-column align-items-center justify-content-between">
                      <div className="text-center mb-4">
                        <h3 className="fw-bold">{plano.nome.toUpperCase()}</h3>
                        <h2 className="display-4 fw-bold" style={{ color: '#FF8C00' }}>R$ {plano.preco}</h2>
                      </div>
                      
                      <ListGroup variant="flush" className="bg-transparent mb-4 flex-grow-1">
                        {plano.beneficios.split(',').map((beneficio, i) => (
                          <ListGroup.Item key={i} className="bg-transparent text-white border-secondary px-0">
                            {/*<CheckCircle size={18} color="#FF8C00" className="me-2" />*/}
                            {beneficio.trim()}
                          </ListGroup.Item>
                        ))}
                      </ListGroup>

                     {/*<button className="btn btn-warning w-100 fw-bold py-2 mt-auto" style={{ backgroundColor: '#FF8C00', color: '#000' }}>
                        MATRICULE-SE JÁ
                      </button>*/}
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <Col className="text-center"><p>Nenhum plano cadastrado no momento.</p></Col>
            )}
          </Row>
        </Container>
      </section>

      {/* Nova Seção de Contato de Atendimento da Academia */}
      <section id="contato" className="py-5 bg-dark">
        <Container>
          <h2 className="text-center display-5 fw-bold mb-5" data-aos="fade-down">
            FALE <span style={{ color: '#FF8C00' }}>CONOSCO</span>
          </h2>
          <Row className="justify-content-center text-center g-4">
            {info.whatsapp && (
              <Col md={3} data-aos="zoom-in">
                <a 
                  href={`https://wa.me/55${info.whatsapp}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-decoration-none text-white card-link"
                >
                  <Card className="bg-black border-secondary p-4 h-100 hover-zoom">
                    <MessageCircle color="#25D366" size={40} className="mx-auto mb-3" />
                    <h5>WhatsApp</h5>
                    <p className="text-muted small">Chame no suporte</p>
                  </Card>
                </a>
              </Col>
            )}

            {info.instagram && (
              <Col md={3} data-aos="zoom-in" data-aos-delay="100">
                <a 
                  href={`https://instagram.com/${info.instagram}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-decoration-none text-white card-link"
                >
                  <Card className="bg-black border-secondary p-4 h-100 hover-zoom">
                    <Instagram color="#E1306C" size={40} className="mx-auto mb-3" />
                    <h5>Instagram</h5>
                    <p className="text-muted small">Siga nosso perfil</p>
                  </Card>
                </a>
              </Col>
            )}

            {info.emailContato && (
              <Col md={3} data-aos="zoom-in" data-aos-delay="200">
                <a 
                  href={`mailto:${info.emailContato}`} 
                  className="text-decoration-none text-white card-link"
                >
                  <Card className="bg-black border-secondary p-4 h-100 hover-zoom">
                    <Mail color="#FF8C00" size={40} className="mx-auto mb-3" />
                    <h5>E-mail</h5>
                    <p className="text-muted small">Envie uma mensagem</p>
                  </Card>
                </a>
              </Col>
            )}
          </Row>
        </Container>
      </section>

      {/* Footer / Localização */}
      <footer id="contato" className="py-5 bg-black border-top border-warning">
        <Container className="text-center">
          <div className="mb-3">
            <MapPin color="#FF8C00" size={32} />
          </div>
          <p className="fs-5 mb-4">{info.endereco}</p>
          <hr className="bg-secondary" />
          <p className="mb-0 text-muted">
            © {new Date().getFullYear()} <span style={{ color: '#FF8C00' }}>{info.nome}</span> - Todos os direitos reservados.
            Desenvolvido por Mauro Pereira dos Santos - email:mauropereira1096@gmail.com
          </p>
        </Container>
      </footer>
    </div>
  );
};

export default Home;